import { render } from "./grid-settings.vue?vue&type=template&id=fe327008"
import script from "./grid-settings.vue?vue&type=script&lang=js"
export * from "./grid-settings.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__